<div class="helping">
  <div class="main">
    <div class="top">
      <div class="background">
        <div class="title">我们能为您提供什么帮助？</div>
        <div class="search">
          <input
            type="text"
            [(ngModel)]="query"
            (keydown.enter)="search()"
            placeholder="输入问题关键词，如：Netflix密码、退款、ChatGPT…"
          />
          <button (click)="search()">搜索</button>
        </div>
        <div class="hot">
          <div class="part1">
            <img
              src="../../../../assets/images/help/Icon-flame.png"
              alt=""
            />热门搜索：
          </div>
          <div class="part2">
            <div
              class="item"
              *ngFor="let item of hot"
              (click)="gotoArticle(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-outlet></router-outlet>
    <div class="loading-overlay" *ngIf="loading">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
  </div>

  <app-help-anchor [list]="categories"></app-help-anchor>
</div>
